module.exports = __webpack_public_path__ + "static/media/toyota_gt86_red.d0e02e10.webp";